import { environment, unleashConfig } from '@/config';

function customFetch(url: string, init?: RequestInit): Promise<Response> {
  const next: RequestInit = { ...init };
  next.headers = new Headers(init?.headers);
  next.headers.set('X-UI-AppName', 'Comet');
  return fetch(url, next);
}

export default {
  url: unleashConfig.url,
  appName: unleashConfig.appName,
  fetch: customFetch,
  clientKey: unleashConfig.clientKey,
  disableMetrics: true,
  usePOSTrequests: true,
  environment: environment === 'production' ? 'production' : 'development'
};
